<!--
    Styles
-->

<style scoped>


    /* stats */

    .prices {
        justify-content: space-between;
    }


    /* info */

    .info .label {
        justify-content: space-between;
    }
    .info .label span:first-child {
        margin-right: 12px;
    }


    /* legend */

    .legend {
        padding: 8px 16px;
        background: var(--cl-white-dark)
    }
    .legend i {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 6px;
        margin-right: 4px;
        margin-left: 24px;
        background: currentColor;
    }
    .legend i:first-child {
        margin-left: 0;
    }

</style>



<!--
    Template
-->

<template>
    <div class="prices u-row">


        <!-- info -->

        <div class="info">

            <p class="label u-row">
                <span>平均成約価格：</span>
                <span class="t15 w7">{{ data.averageDealPrice | price }}</span>
            </p>

            <p class="label u-row">
                <span>平均坪単価：</span>
                <span class="t15 w7">{{ data.averageDealPriceBySqm * tsubo | price }}</span>
            </p>

        </div>


        <!-- legend -->

        <div class="legend u-row">

            <i class="cl-blue" />
            <p>平均成約価格</p>

            <i class="cl-orange" />
            <p>平均坪単価</p>

        </div>


    </div>
</template>



<!--
    Scripts
-->

<script>

    import {price} from '@/common/helpers/parse'

    export default {

        props: [
            'data'
        ],

        filters: {
            price
        }

    }

</script>

